import React from "react";
import ServiceAreaOneMultiImg from "./ServiceAreaOneMultiImg";
import { CHAPA_SERVICES_DATA } from "../data/chapaData";

// Icon mapping (default icons for services)
const defaultIcons = [
  "../assets/img/icon/picing-icon_2-3.svg",
  "../assets/img/icon/wcu-icon_2-5.svg",
  "../assets/img/icon/service-icon_1-3.svg",
  "../assets/img/icon/service-icon_1-2.svg",
  "../assets/img/icon/wcu-icon_2-6.svg",
];

// Transform data from chapaData.js to the format expected by ServiceAreaOneMultiImg
const servicesData = CHAPA_SERVICES_DATA.map((service, index) => ({
  icon: defaultIcons[index % defaultIcons.length],
  title: service.title,
  text: service.description.split('\n')[0].trim(), // First paragraph as summary
  link: `/chapa-y-pintura/${service.slug}`,
  image: service.images?.[0] || "../assets/img/service/service-1-3.png",
  altIcon: `Icono ${service.title}`,
  altImage: `Imagen ${service.title}`,
}));

const ChapaYPinturaServicesData = ({title}) => {
  return (
    <div>
      {/* Any other content */}
      <ServiceAreaOneMultiImg
        categoryService={title}
        services={servicesData}
      />
    </div>
  );
};

export default ChapaYPinturaServicesData;
